import {useTranslation} from "react-i18next";
import {IconVisitorManagementDesign} from "../../../../../../components/buttons/IconButtons";
import BodyValidation from "../../Components/BodyValidation";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 * @param {string} title - Title text to display in the step (translated using `t`).
 * @param {string} subtitle - Subtitle text to display below the title (translated using `t`).
 * @param {function} onClick - Callback function triggered when the next button is clicked.
 * @param {boolean} showBtnNext - Determines whether the next button is visible.
 */
const SubmittingStep = ({ title, subtitle, onClick, showBtnNext}) => {
    const { t } = useTranslation();

    return (
           <BodyValidation
                click={ onClick }
                showLogoFooter={false}
                showBtnNext={showBtnNext}
                showBtnPrev={false}
            >
                <div className="row">
                    <div className="col-12 d-flex flex-column justify-content-center align-items-center">
                        <p className="fs-24-to-18 ibl-font-w-600 font-color-general-950 text-center">{t(title)}</p>
                        <p className="fs-20-to-14 ibl-font-w-400 font-color-general-950 text-center">{t(subtitle)}</p>
                    </div>
                </div>

                <div className="d-flex justify-content-center align-items-center pt-3">
                    <div className="icon-identity-validation-container">
                        <IconVisitorManagementDesign className="w-100 h-100" />
                    </div>
                </div>

             </BodyValidation>
    )

}

export default SubmittingStep
